module.exports = __webpack_public_path__ + "static/media/noimg.aaeabab6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assert/images/noimg.svg
// module id = 587
// module chunks = 1